import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: localStorage.getItem("accessToken") || null,
    customerType: "null",
    cashAmount: 0,
    rewardAmount: 0,
    creditAmount: null,
    apiURL: "https://api.jayjinglotto.com", // No slash at the end or url //"https://api.xxx.com"
    siteName: "jayjinglotto.com",
    appName: "jayjinglotto",
    appTitle: 'jayjinglotto',
    siteUrl: "https://jayjinglotto.com", // No slash at the end or url  
    reCaptchaKey: '6LdrepAqAAAAAI_944t89VDNIMsjBWbAtLlvQa1J', // google recaptcha v2 only
    username:  localStorage.getItem("username") || null,
    lottoType: [
      {
        lottoType: 1,
        lottoName: 'PingPong',
        lottoDesc: 'จับยี่กี'
      },
      {
        lottoType: 2,
        lottoName: 'PingPongVIP',
        lottoDesc: 'จับยี่กี VIP'
      },
      {
        lottoType: 3,
        lottoName: 'ThaiLotto',
        lottoDesc: 'หวยรัฐบาลไทย'
      },
      {
        lottoType: 4,
        lottoName: 'LaosLotto',
        lottoDesc: 'หวยลาว'
      },
      {
        lottoType: 5,
        lottoName: 'ThaiStockLotto',
        lottoDesc: 'หุ้นไทย'
      },
      {
        lottoType: 6,
        lottoName: 'HangSengMorningLotto',
        lottoDesc: 'หุ้นฮั่งเส็ง เช้า'
      },
      {
        lottoType: 7,
        lottoName: 'HangSengAfternoonLotto',
        lottoDesc: 'หุ้นฮั่งเส็ง บ่าย'
      },
      {
        lottoType: 8,
        lottoName: 'SingaporeLotto',
        lottoDesc: 'หุ้นสิงคโปร์'
      },
      {
        lottoType: 9,
        lottoName: 'HanoiLotto',
        lottoDesc: 'หวยฮานอย'
      },
      {
        lottoType: 10,
        lottoName: 'NikeiMorningLotto',
        lottoDesc: 'นิเคอิ เช้า'
      },
      {
        lottoType: 11,
        lottoName: 'NikeiAfternoonLotto',
        lottoDesc: 'นิเคอิ บ่าย'
      },
      {
        lottoType: 12,
        lottoName: 'DownjoneLotto',
        lottoDesc: 'หุ้นดาวโจนส์'
      },
      {
        lottoType: 13,
        lottoName: 'ThaiAomsinLotto',
        lottoDesc: 'หวยออมสิน'
      },
      {
        lottoType: 14,
        lottoName: 'ThaiBAAC',
        lottoDesc: 'หวย ธกส'
      },
      {
        lottoType: 15,
        lottoName: 'KoreaLotto',
        lottoDesc: 'หุ้นเกาหลี'
      },
      {
        lottoType: 16,
        lottoName: 'ChinaMorningLotto',
        lottoDesc: 'หุ้นจีน เช้า'
      },
      {
        lottoType: 17,
        lottoName: 'ChinaAfternoonLotto',
        lottoDesc: 'หุ้นจีน บ่าย'
      },
      {
        lottoType: 18,
        lottoName: 'TaiwanLotto',
        lottoDesc: 'หุ้นไต้หวัน'
      },
      {
        lottoType: 19,
        lottoName: 'EgyptLotto',
        lottoDesc: 'หุ้นอียิปต์'
      },
      {
        lottoType: 20,
        lottoName: 'GermanLotto',
        lottoDesc: 'หุ้นเยอรมัน'
      },
      {
        lottoType: 21,
        lottoName: 'EnglandLotto',
        lottoDesc: 'หุ้นอังกฤษ'
      },
      {
        lottoType: 22,
        lottoName: 'RussiaLotto',
        lottoDesc: 'หุ้นรัสเซีย'
      },
      {
        lottoType: 23,
        lottoName: 'IndiaLotto',
        lottoDesc: 'หุ้นอินเดีย'
      },
      {
        lottoType: 24,
        lottoName: 'MalaysiaLotto',
        lottoDesc: 'หวยมาเลย์'
      },
      {
        lottoType: 25,
        lottoName: 'HanoiExtraLotto',
        lottoDesc: 'ฮานอยพิเศษ'
      },
      {
        lottoType: 26,
        lottoName: 'LaosLottoSet',
        lottoDesc: 'หวยชุดลาว'
      },
      {
        lottoType: 27,
        lottoName: 'HanoiLottoSet',
        lottoDesc: 'หวยชุดฮานอย'
      },
      {
        lottoType: 28,
        lottoName: 'Malaysia4DLottoSet',
        lottoDesc: 'หวยชุดมาเลย์'
      },
      {
        lottoType: 29,
        lottoName: 'JackpotLotto',
        lottoDesc: 'โบนัส'
      },
      {
        lottoType: 30,
        lottoName: 'ETH',
        lottoDesc: 'เหรียญ ETH'
      },
      {
        lottoType: 31,
        lottoName: 'BITCOIN',
        lottoDesc: 'เหรียญ BITCOIN'
      },
      {
        lottoType: 32,
        lottoName: 'Apple',
        lottoDesc: 'หุ้น Apple'
      },
      {
        lottoType: 33,
        lottoName: 'Tesla',
        lottoDesc: 'หุ้น Tesla'
      }
    ]
  },
  mutations: {
    SET_ACCESS_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      if (accessToken !== null) {
        localStorage.setItem("accessToken", accessToken);
      } else {
        localStorage.removeItem("accessToken");
      }
    },
    SET_CUSTOMER_TYPE(state, customerType) {
      state.customerType = customerType;
    },
    SET_CASH_AMOUNT(state, cashAmount) {
      state.cashAmount = cashAmount;
    },
    SET_REWARD_AMOUNT(state, rewardAmount) {
      state.rewardAmount = rewardAmount;
    },
    SET_USERNAME(state, username) {
      state.username = username;
      if (username !== null) {
        localStorage.setItem("username", username);
      } else {
        localStorage.removeItem("username");
      }
    }
  },
  getters: {
    getAccessToken(state) {
      return state.accessToken;
    },
    getCustomerType(state) {
      return state.customerType;
    },
    getCashAmount(state) {
      return state.cashAmount;
    },
    getRewardAmount(state) {
      return state.rewardAmount;
    },
    getUsername(state) {
      return state.username;
    },
    getLottoType(state) {
      return state.lottoType;
    },
    getApiUrl(state) {
      return state.apiURL;
    },
    getSiteName(state) {
      return state.siteName;
    },
    getSiteUrl(state) {
      return state.siteUrl;
    },
    getAppName(state) {
      return state.appName;
    },
    getAppTitle(state) {
      return state.appTitle;
    },
    getReCaptchaKey(state) {
      return state.reCaptchaKey;
    }
  },
  actions: {
    async setAccessToken({
      commit
    }, data) {
      try {
        commit("SET_ACCESS_TOKEN", data[0]);
        commit("SET_USERNAME", data[1]);
        // axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("accessToken");
        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async setCustomerType({
      commit
    }, customerType) {
      try {
        commit("SET_CUSTOMER_TYPE", customerType);
        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async setCashAmount({
      commit
    }, cashAmount) {
      try {
        commit("SET_CASH_AMOUNT", cashAmount);
        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async setRewardAmount({
      commit
    }, rewardAmount) {
      try {
        commit("SET_REWARD_AMOUNT", rewardAmount);
        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    revokeToken({
        commit
    }) {
        commit("SET_ACCESS_TOKEN", null);
        commit("SET_USERNAME", null);
    }
  },
  modules: {}
});
